import { useQuery } from "react-query";
import { Get } from "../utils/api";
import { useAuth0 } from "@auth0/auth0-react";

import { useNavigate } from "react-router-dom";
import { Order } from "../../types/api/Order";

export default (sellerOrgId: string, buyerOrgId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const navigate = useNavigate();
  return useQuery<Order[]>(
    `customers_${sellerOrgId}_${buyerOrgId}`,
    async () => {
      return await Get<Order[]>(
        `/api/order/organization/${sellerOrgId}/purchasing_organization/${buyerOrgId}`,
        await getAccessTokenSilently()
      );
    }
  );
};
